import type { FC } from 'react';

import { StorefrontContainer } from '@/features/storefront/components/StorefrontContainer';
import type { ProductViewProps } from '@/features/storefront/layouts/product/types';
import { PartRegion } from '@/features/storefront/parts/PartRegion';

/**
 * A sports product page: the kit wider than the buy column, which sticks
 * beside it on a wide screen. The breadcrumb above and the related kit below
 * are drawn by the page itself at its own width.
 */
export const Product: FC<ProductViewProps> = () => (
  <StorefrontContainer className="grid gap-10 py-8 lg:grid-cols-[minmax(0,1.3fr)_minmax(0,1fr)] lg:gap-14">
    <PartRegion name="gallery" className="min-w-0" />
    <PartRegion name="main" className="min-w-0 lg:sticky lg:top-28 lg:self-start" />
  </StorefrontContainer>
);
